module.exports = {
	catagory: "brewing methods",
	defaultImage: "https://images.unsplash.com/photo-1541102386797-2039013069c8?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTMyfHx0ZWFwb3R8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60",
	questions: [
		{
			questionText: `Is it possible to brew iced tea with tea bags?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
					"yes"
				],
				incorrect: [
					"no"
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},

		{
			questionText: `What temperature range is used to brew green tea?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
				],
				incorrect: [
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},

		{
			questionText: `What temperature range is used to brew yellow tea?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
				],
				incorrect: [
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},

		{
			questionText: `What temperature range is used to brew white tea?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
				],
				incorrect: [
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},

		{
			questionText: `What temperature range is used to brew wulong tea?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
				],
				incorrect: [
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},

		{
			questionText: `What temperature range is used to brew red tea?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
				],
				incorrect: [
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},

		{
			questionText: `What temperature range is used to brew fermented tea?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
				],
				incorrect: [
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},

		{
			questionText: `What temperature range is used to brew purple tea?`,
			questionDifficulty: 1,
			answerOptions: {
				correct: [
				],
				incorrect: [
				]
			},
			response: ``,
			tags: [""],
			citations: ``,
			image: ``
		},
	]
}